﻿window.info_mediated_tp_loss_edit = function () {
    var instance = {
        init: function () {

            im_decimal.mask(".decimalmask");
            im_integer.mask(".integermask");
        }
    };
    var im_decimal = Inputmask("decimal", {
        radixPoint: ',',
        digits: 6,
        integerDigits: 12,
        rightAlign: false,
        allowMinus: false
    });
    var im_integer = Inputmask("integer", {
        integerDigits: 3,
        rightAlign: false,
        allowMinus: false
    });
    return instance;
}();
